import Vue from 'vue'
import VueRouter from 'vue-router'
import VueGtm from 'vue-gtm';
import gtmOptions from './gtm-options.js'

Vue.use(VueRouter)
Vue.use(VueGtm, gtmOptions);

import axios from "axios";
import debounce from 'lodash.debounce';

// Components
import SearchResult from './components/search-result.vue';
import LoadingSpinner from './components/loading-spinner.vue';

// Vue Router settings
const router = new VueRouter({
  mode: 'history',
});

// Graph QL API
const solutionsApi = '/api';

const query = `
  query solutionsSearch($query:String!) {
    entries(
      section: "solutions",
      search: $query,
      orderBy: "score"
    ) {
      id
      title
      url
      ...on solutionsListing_Entry {
        summary
      }
      ...on solution_Entry {
        summary
      }
    }
  }
`;

// CancelTokens for canceling previous Axios requests.
const CancelToken = axios.CancelToken;
let source;

// Simple component
const SearchResultsError = {
  props: ['isVisible']
}

if (document.getElementById('solutions-search') != null) {
  new Vue({
    router,
    data() {
      return {
        query: '',
        queryIsDirty: false,
        isLoading: false,
        prerendered: window.__SEARCH__.prerendered || false,
        noResults: false,
        searchResults: []
      }
    },
    methods: {
      fetchEntries: debounce(function () {
        this.prerendered = false;
        this.queryIsDirty = false;

        if (source) {
          source.cancel();
        }
        source = axios.CancelToken.source();

        if (this.query.length < 2) {
          this.noResults = false;
          this.searchResults = [];
          return;
        } else {
          this.isLoading = true;

          axios.post(solutionsApi, {
              query: query,
              variables: {"query": this.query}
            }, {
              cancelToken: source.token
            })
            .then(response => {
              this.isLoading = false;
              this.searchResults = response.data.data.entries;
              this.noResults = this.searchResults.length < 1;
              this.track();
            })
            .catch(error => {
              if (axios.isCancel(error)) {
                console.log(error.message);
              } else {
                this.isLoading = false;
                console.log(error.message);
              }
            })
            .finally(() => {
            });
        }
      }, 300),
      track: function() {
        this.$gtm.trackEvent({
          event: 'search',
          category: 'solutions',
          searchKeywords: this.query,
        });
      }
    },
    computed: {
      showNoResults: function() {
        return (this.noResults && this.isLoading === false);
      },
      showDefaultContent: function() {
        return (this.searchResults.length === 0 && this.noResults === false && this.isLoading === false);
      },
    },
    watch: {
      query: function (newVal) {
        // query is "dirty" while the user is still typing
        this.queryIsDirty = true;
        this.fetchEntries();
      }
    },
    created: function() {
      this.query = this.$route.query.search || '';
      if (!this.prerendered) {
        this.fetchEntries();
      }
    },
    components: {
      SearchResult,
      LoadingSpinner,
      SearchResultsError
    }
  }).$mount('#solutions-search')
}
